<app-header-full></app-header-full>
<section class="pb-2">
    <h1>Thank you for your purchase! We are so excited you are choosing to continue with WeShape!</h1>
    <h3>Your subscription will be charged at the end of the free trial period.</h3>
    <p>Please click the button below to return to your program!</p>
    <div class="blue-btn"><a class="navbar-link" (click)="returnToProduct()">Return to WeShape</a></div>
</section>
<app-footer></app-footer>
